import { render } from "./NoUPFModeToggle.vue?vue&type=template&id=168ebb51&scoped=true"
import script from "./NoUPFModeToggle.vue?vue&type=script&lang=js"
export * from "./NoUPFModeToggle.vue?vue&type=script&lang=js"

import "./NoUPFModeToggle.vue?vue&type=style&index=0&id=168ebb51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168ebb51"]])

export default __exports__